interface ScoreRingProps {
  score: number
  maxScore: number
  size?: number
}

const scoreColor = (score: number, max: number) => {
  const pct = (score / max) * 100
  if (pct >= 80) return 'var(--color-success)'
  if (pct >= 65) return 'var(--accent-copper)'
  if (pct >= 50) return 'var(--color-warning)'
  return 'var(--color-danger)'
}

export const ScoreRing = ({ score, maxScore, size = 44 }: ScoreRingProps) => {
  const pct = maxScore > 0 ? (score / maxScore) * 100 : 0
  const r = (size - 6) / 2
  const circ = 2 * Math.PI * r
  const offset = circ - (pct / 100) * circ

  return (
    <div className="score-ring" style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="var(--border-color)"
          strokeWidth={3}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={scoreColor(score, maxScore)}
          strokeWidth={3}
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <span className="score-ring-label" style={{ fontSize: size > 40 ? '0.85rem' : '0.7rem' }}>
        {Math.round(pct)}
      </span>
    </div>
  )
}
